import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
  Tabs,
  Tab
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useListContext,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
  DateInput,
  ExportButton,
  ListContextProvider
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import AddressField from 'src/pages/admin/components/AddressField';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import { chains } from 'src/assets/data';

const EventTabs = () => {
  const { filterValues, setFilters } = useListContext();
  const [tabValue, setTabValue] = useState(filterValues?.event || '');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
    const newFilter = { ...filterValues };
    if (newValue === '') {
      delete newFilter.event;
    } else {
      newFilter.event = newValue;
    }
    setFilters(newFilter);
  };

  return (
    <Tabs value={tabValue} onChange={handleChange} sx={{ px: 2, pt: 2 }}>
      <Tab label="All" value="" />
      <Tab label="Buy" value="BUY" />
      <Tab label="Sell" value="SELL" />
    </Tabs>
  );
};

const ListFilter = (props: any) => (
  <Filter {...props}>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <TextInput source="id" label="module.transactions.transactionId" alwaysOn />
    </FilterGroup>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <TextInput source="userId" label="module.transactions.userId" alwaysOn />
    </FilterGroup>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <DateInput source="startTime" label="From Time" helperText={<span style={{ color: 'red' }}></span>} />
    </FilterGroup>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <DateInput source="endTime" label="To Time" helperText={<span style={{ color: 'red' }}></span>} />
    </FilterGroup>
  </Filter>
);

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();
  const controller = useListController({ resource: 'transactions', perPage: 10 });

  return (
    <PermissionGuard resource="transactions" action="read" fallback={<ErrorPage403 />}> 
     <ListContextProvider value={controller}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.transactions')}
          links={[
            { name: translate('resource.transactions') },
            { name: translate('resource.list') },
          ]}
          action={
            <PermissionGuard resource="transactions" action="download" fallback={<></>}>
              <ExportButton variant="contained" color='secondary' size='medium' onClick={(e) => e.preventDefault()} />
            </PermissionGuard>
          }
        />
        <EventTabs />

        <Card sx={{ pb: 2 }}>
            <List
              {...controller}
              actions={false}
              filters={<ListFilter />}
              exporter={false}
              empty={false}
            >
              <Box sx={{ overflow: 'auto' }}>
                <Datagrid
                  rowClick={false}
                  sx={{
                    '.RaBulkActionsToolbar-toolbar': {
                      position: 'relative !important',
                      transform: 'none !important',
                    },
                  }}
                >
                  <FunctionField
                    label="module.transactions.transactionId"
                    render={(record: any) => <AddressField address={record.id} />}
                    sortable={false}
                  />
                  <TextField source="userId" label="module.transactions.userId" sortable={false} />
                  <TextField source="event" label="module.transactions.event" sortable={false} />
                  <TextField source="amount" label="module.transactions.amount" sortable={false} />
                  <TextField source="balanceBefore" label="module.transactions.balanceBefore" sortable={false} />
                  <TextField source="balanceAfter" label="module.transactions.balanceAfter" sortable={false} />
                  <TextField source="mode" label="module.transactions.mode" sortable={false} />
                  <TextField source="timestamp" label="module.transactions.timestamp" sortable={false} />
                </Datagrid>
              </Box>
            </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
      </ListContextProvider>
    </PermissionGuard>
  );
};

export default View;